module.exports = __webpack_public_path__ + "apple-touch-icon-ddbf3e29266f01f8e853df560f9973be.png";